import styled from "styled-components";
import { FileTextOutlined, CloseOutlined } from "@ant-design/icons";
import { TEAL } from "../../EmployeeSkillsBridgerV2.constants";

// ─── Panel title row ──────────────────────────────────────────────────────────

export const JdModalTitleStyled = styled.span`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const JdFileIconStyled = styled(FileTextOutlined)`
  color: ${TEAL};
  font-size: 18px;
`;

export const JdCloseIconStyled = styled(CloseOutlined)`
  cursor: pointer;
  font-size: 14px;
  color: rgba(0, 0, 0, 0.45);

  &:hover {
    color: rgba(0, 0, 0, 0.75);
  }
`;
